import styled from 'styled-components';
import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import AreYouReadyBackground from 'src/images/AreYouReadyBackground.png';

export const BannerContainer = styled.div`
  max-width: 100vw !important;
  background: url(${AreYouReadyBackground});
  background-position: 55% 95%;
  background-repeat: no-repeat;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 160px;

  @media screen and (max-width: ${layout.lg}) {
    background-position: 55% 65%;
  }

  @media screen and (max-width: ${layout.sm}) {
    background-position: 55% 80%;
  }

  @media screen and (max-width: ${layout.xxs}) {
    background-position: 55% -180px;
    background-size: 650% 135%;
  }
`

export const BannerContent = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  display: grid;
  box-sizing: border-box;
  padding: 150px 0;
  grid-row-gap: 4rem;

  > h1 {
    justify-self: center;
    font-family: 'Walsheim', 'Lato';
    transform: rotate(-6.48deg);
  }

  @media screen and (max-width: ${layout.sm}) {
    padding: 60px 0;

    > h1 {
      line-height: 3.8rem;
      max-width: 300px;
    }
  }
`

export const EngagementCard = styled.div`
  justify-self: left;
  background-color: ${palette.black};
  min-width: 60%;

  @media screen and (max-width: ${layout.sm}) {
    width: 100%;
    justify-self: center;
  }
`

export const EngagementCardContent = styled.div`
  max-width: 900px;
  margin-left: auto;
  box-sizing: border-box;
  padding: 3.75rem 5rem;
  display: grid;
  grid-row-gap: 3.5rem;
  justify-content: left;

  a {
    font-size: 25px;
    border-radius: 18px;
    font-weight: 900;
    justify-self: left;
    padding: 1.8rem 4.5rem;
  }

  @media screen and (max-width: ${layout.subLg}) {
    padding: 2.5rem 4rem;
    max-width: 600px;

    a {
      font-size: 18px;
      padding: 1.4rem 4rem;
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    justify-self: center;
    margin: 0 auto;
    padding: 2.5rem 1rem;

    > p {
      box-sizing: border-box;
      padding: 0 3.2rem;
      justify-self: center;
    }

    a {
      font-size: 1rem;
      justify-self: center;
      padding: 1rem;
      width: 100%;
      max-width: 350px;
    }
  }
`
